<template>
  <div>

    <v-fade-transition mode="out-in">
      <article 
        v-if="filteredSlabItems.length == 0" 
        class="message is-info is-fullwidth">
        <div class="message-body">
          <span v-if="!projectId">
            Please select a project.
          </span>
          <span v-else> 
            No slab items available for this project.
            <span class="help">
              Note that only slabs that the ordering department has decided to make in-house will appear in this list.
            </span>
          </span>
        </div>
      </article>
    
      <table
        :key="projectId"
        v-else 
        class="table is-fullwidth is-hoverable is-clickable has-small-font">

        <thead>
          <tr>
            <th>
              <v-checkbox
                :value="allSelected"
                @input="toggleAllSelected($event)">
              </v-checkbox>
            </th>
            <th 
              v-for="(header, i) in headers"
              :key="i">
              {{ header }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr 
            class="v-centered"
            v-for="item in filteredSlabItems"
            :key="item.id">
            <td>
              <v-checkbox
                :value="selected.indexOf(item.id) != -1"
                @input="toggleSelected(item)">
              </v-checkbox>
            </td>
            <td>
              {{ item.backing_product_master.name }}
            </td>
            <td>
              {{ item.facing_product_master.name }}
            </td>
            <td>
              {{ item.slab_product_master.name }}
            </td>
            <td>
              {{ lwt(item) }}
            </td>
            <td>
              {{ item.finished_qty }}
            </td>
            <td>
              {{ item.location }}
            </td>
            <td>
              {{ item.description }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-fade-transition>
  </div>
</template>

<script>
import VFadeTransition from '@/components/transitions/VFadeTransition'
import VCheckbox from '@/components/base/VCheckbox'

export default {
  props: {
    projectId: {
      type: [String, Number]
    },
    exclude: {
      type: Array
    }
  },
  components: {
    VFadeTransition,
    VCheckbox
  },
  data() {
    return {
      slabItems: [],
      selected: [],
      allSelected: false,
      headers: [
        'Back Product', 'Facing Product', 'Finished Product', 'Size', 'Quantity', 'Location', 'Description'
      ]
    }
  },
  computed: {
    selectedItems() {
      return this.slabItems.filter(d => 
        this.selected.indexOf(d.id) != -1
      )
    },
    filteredSlabItems() {
      if (this.exclude) {
        return this.slabItems.filter(d => this.exclude.indexOf(d.id) == -1);
      } else {
        return this.slabItems
      }
    }
  },
  watch: {
    projectId: {
      handler(projectId) {
        this.getSlabItems(projectId);
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.projectId) {
        this.getSlabItems(this.projectId);
      }
    },
    getSlabItems(projectId) {
      this.$http.productionSheetsItems.get({
        project_id: projectId,
        per_page: 1000
      }).then(resp => {
        this.slabItems = resp.data.results;
      })
    },
    lwt(item) {
      return `L${item.length_in_str}" x W${item.width_in_str}" x T${item.s_thick_in_str}"`
    },
    toggleSelected(item) {
      const index = this.selected.indexOf(item.id);
      if (index == -1) {
        this.select(item);
      } else {
        this.deselect(item.id);
      }
    },
    select(item) {
      this.selected.push(item.id);
      this.$emit('select', item);
    },
    deselect(id) {
      this.$emit('deselect', id);

      let index = this.selected.indexOf(id);
      this.selected.splice(index, 1);
      if (this.selected.length == 0) {
        this.allSelected = false;
      }
    },
    toggleAllSelected(v) {
      this.allSelected = v;
      const { selected } = this;

      if (v) {
        this.slabItems.forEach(item => {
          if (!selected.includes(item.id)) {
            this.select(item);
          }
        })
      } else {
        this.slabItems.forEach(item => {
          if (selected.includes(item.id)) {
            this.deselect(item.id);
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';

.justify-space-between {
  justify-content: space-between;
}
</style>